/** Vite base URL so local assets load correctly when deployed (e.g. / on hortera.org). */
const baseUrl = (typeof import.meta !== 'undefined' && (import.meta as { env?: { BASE_URL?: string } }).env?.BASE_URL) || '/';

export type StylePreset = {
	id: string;
	key: 'mediterranean' | 'modern' | 'minimalist' | 'cottage' | 'japanese' | 'tropical' | 'rustic' | 'coastal' | 'scandinavian' | 'traditional';
	title: string;
	description: string;
	imageUrl?: string;
};

export const stylePresets: StylePreset[] = [
	{ 
		id: 's1', 
		key: 'modern', 
		title: 'Modern', 
		description: 'Clean lines, minimal planting.',
		imageUrl: baseUrl + 'questionnaire/styles-optimized/modern.webp'
	},
	{ 
		id: 's2', 
		key: 'mediterranean', 
		title: 'Mediterranean', 
		description: 'Sun-baked warmth: terracotta, olives, drought-tolerant plants, wrought iron.',
		imageUrl: baseUrl + 'questionnaire/styles-optimized/mediterranean.webp'
	},
	{ 
		id: 's3', 
		key: 'minimalist', 
		title: 'Minimalist', 
		description: 'Simple palettes, calm spaces.',
		imageUrl: baseUrl + 'questionnaire/styles-optimized/minimalist.webp'
	},
	{ 
		id: 's4', 
		key: 'cottage', 
		title: 'Cottage', 
		description: 'Informal, colorful perennials.',
		imageUrl: baseUrl + 'questionnaire/styles-optimized/cottage.webp'
	},
	{ 
		id: 's5', 
		key: 'japanese', 
		title: 'Japanese Zen', 
		description: 'Contemplative: raked gravel, rocks, bamboo, water, minimal planting.',
		imageUrl: baseUrl + 'questionnaire/styles-optimized/japanese.webp'
	},
	{ 
		id: 's6', 
		key: 'tropical', 
		title: 'Tropical', 
		description: 'Lush foliage, palms, bold leaves and bright accents.',
		imageUrl: baseUrl + 'questionnaire/styles-optimized/tropical.webp'
	},
	{ 
		id: 's7', 
		key: 'rustic', 
		title: 'Rustic', 
		description: 'Weathered wood, natural stone, country charm.',
		imageUrl: baseUrl + 'questionnaire/styles-optimized/rustic.webp'
	},
	{ 
		id: 's8', 
		key: 'coastal', 
		title: 'Coastal', 
		description: 'Beach/ocean vibe: driftwood, dunes, ornamental grasses, soft blues and whites.',
		imageUrl: baseUrl + 'questionnaire/styles-optimized/coastal.webp'
	},
	{ 
		id: 's9', 
		key: 'scandinavian', 
		title: 'Scandinavian', 
		description: 'Light wood, hygge, simple forms and natural light.',
		imageUrl: baseUrl + 'questionnaire/styles-optimized/scandinavian.webp'
	},
	{ 
		id: 's10', 
		key: 'traditional', 
		title: 'Traditional', 
		description: 'Classic borders, hedges, roses and formal touches.',
		imageUrl: baseUrl + 'questionnaire/styles-optimized/traditional.webp'
	}
];

export const stylePresetsByKey: Record<StylePreset['key'], StylePreset> =
	Object.fromEntries(stylePresets.map(s => [s.key, s])) as Record<StylePreset['key'], StylePreset>;


